
import { Component, Prop } from 'vue-property-decorator';
import Page from '@/Page.vue';
import { AuditEscalationGroupModel, GroupModel, PermissionTypeEnum, PlanItemModel, TenantUserModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { EventTypeEnum } from '@/libs/core/models/event-type-enum';
import TakeSolvingItem from '@/libs/issues-solving/components/TakeSolvingItem.vue';
import { groupsStore } from '@/libs/groups/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';

@Component({
    components: { TakeSolvingItem },
})
export default class IssueSolvingItem extends Page {
    @Prop() item!: PlanItemModel;
    @Prop({ required: true }) auditEscalationGroups!: AuditEscalationGroupModel[];
    protected tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    protected takeItemId: string | null | undefined = null;

    getFontColor(color: string | undefined): string {
        return this.useWhiteFont(color) ? 'fff' : '000';
    }

    onTakeClick() {
        const isSharedMode: boolean = authStore.useGetter(AuthGetter.GetSharedMode);
        if (isSharedMode) {
            this.setQuery('take', this.item!.id!);
            (window as any).Journaly.publish(EventTypeEnum.QuickLoginRequested);
        } else {
            this.takeItemId = this.item.id;
        }
    }
}
